import React, { FC } from 'react';

// Utils
import { classNames, defaultHandlePlayerClick } from '@sportal365/smp-widget-utils';

// Types
import { ISubscriberInfo } from '../../../../../../../packages/types';
import { INormalizePlayer } from '../../../../types';

interface Props extends INormalizePlayer {
  withReversedDisplay?: boolean;
  handleClick: (info: ISubscriberInfo, clickType: string) => void;
}

export const PlayerInfo: FC<Props> = ({ player, team, withReversedDisplay, handleClick }) => {
  const handlePlayerClick = () => defaultHandlePlayerClick(handleClick, player.id, player.name);

  const lastName = player.name.split(' ').length > 0 ? player.name.split(' ')[1] : '';

  return (
    <a href={player.url} target={player.target} className='no-underline' onClick={handlePlayerClick}>
      <div
        className={classNames(
          {
            'flex gap-1 flex-col tb:gap-2 tb:flex-row-reverse items-center': withReversedDisplay,
            'flex gap-1 flex-col tb:gap-2 tb:flex-row items-center': !withReversedDisplay,
          },
          `player-${player.id}-info-container`,
        )}
      >
        <img
          src={player.image}
          className={classNames(
            { 'rounded-6 w-[42px] tb:w-[64px] h-[42px] tb:h-[64px] self-center tb:self-end': true },
            `player-${player.id}-image`,
          )}
        />
        <div className='text-center tb:text-start'>
          <span
            className={classNames({ 'font-bold text-hiContrast text-5 tb:text-7 hidden tb:block': true }, `player-${player.id}-full-name`)}
          >
            {player.name}
          </span>
          <span
            className={classNames({ 'font-bold text-hiContrast text-5 tb:text-7 block tb:hidden': true }, `player-${player.id}-last-name`)}
          >
            {lastName}
          </span>
          <div
            className={classNames(
              {
                'flex gap-1 items-center mt-1 flex-row justify-center tb:justify-start': true,
                'flex-row-reverse justify-center tb:justify-start': withReversedDisplay,
              },
              `player-${player.id}-team-${team.id}-container`,
            )}
          >
            <img src={team.image} className={classNames({ 'w-4 tb:w-6 h-4 tb:h-6': true }, `player-${player.id}-team-${team.id}-image`)} />
            <span className={classNames({ 'text-4 font-light text-progressTextColor': true }, `player-${player.id}-team-${team.id}-name`)}>
              {team.name}
            </span>
          </div>
        </div>
      </div>
    </a>
  );
};
